/* eslint-disable max-lines-per-function */
import React, { useState, useEffect } from "react";
import { Link, navigate } from "@reach/router";
import { Grid } from "@material-ui/core";
import { useQuery } from "@apollo/client";
import { gql } from "graphql-tag";
import { Input as InputWithLabel } from "components/haven-design/form/inputs";
import { Card, Button } from "components/haven-design";
import { useViewer } from "components/viewer/context";
import { getViewer } from "types/gql-types";
import { VIEWER_QUERY } from "components/auth/query";
import { LoadingSpinner } from "components/graphql-views";
import ErrorMessage from "components/error-message";
import { PasswordValidationType, validatePassword } from "components/login/utils";
import { PasswordValidations, BackToLogin, HavenConnectLoginLogo, LoginCardSubtitle, LoginCardTitle, LoneGrid } from "components/login/components/shared-components";
import { setNewUserPassword } from "./actions";

const FETCH_USER_EXISTANCE = gql`
  query FetchUserExistance($token: String!) {
    userExists(token: $token)
  }
`;

interface Props {
  path: string;
  token?: string;
}

export const NewUser: React.FC<Props> = ({ token }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState<PasswordValidationType[]>([]);

  const viewer = useViewer();
  const { loading, error, data } = useQuery<getViewer>(VIEWER_QUERY);

  const { loading: loadingExists, error: errorExists, data: dataExists } =
    useQuery(FETCH_USER_EXISTANCE, { variables: { token } });


  useEffect(() => {
    if (viewer && data && data.viewer) {
      navigate(data.viewer.isPropManager || data.viewer.isSupervisor ? "/new-user/update" : "/");
    }
  }, [viewer, data]);

  useEffect(() => {
    setErrors(validatePassword(password));
  }, [password]);

  const titleText = dataExists && !dataExists.userExists ? "Link Expired" : "Welcome to Haven Connect!";
  const subtitleText = "First, let's set your password. Your username is your work email address.";
  return (
    <Grid container justifyContent="center" spacing={2} direction="row">
      <Grid item xs={12}>
        <HavenConnectLoginLogo />
      </Grid>
      <Card>
        <LoneGrid><LoginCardTitle title={titleText} /></LoneGrid>

        {(loadingExists || loading) && <LoadingSpinner/>}
        {(errorExists || error) && <ErrorMessage errorMsg="Failed to verify the token"/>}
        {dataExists && (
          dataExists.userExists ? (
            <>
              <LoneGrid><LoginCardSubtitle>{subtitleText}</LoginCardSubtitle></LoneGrid>
              <LoneGrid>
                <Grid item md={8} direction="column" style={{ minWidth: "70%" }}>
                  <InputWithLabel name="pass" type="password" label="Password"
                    onChange={(e) => setPassword(e.target.value.trim())}
                  />
                </Grid>
                <Grid item md={8}><PasswordValidations errors={errors} /></Grid>
                <Grid item md={12}><br/></Grid>
              </LoneGrid>
              <LoneGrid>
                <Button
                  onClick={() => {
                    setIsSubmitting(true);
                    setNewUserPassword(token || "", password)
                      .then(() => navigate("/new-user/update"))
                      .catch(() => setIsSubmitting(false));
                  }}
                  disabled={errors.length > 0 || isSubmitting}
                  size="L"
                  color="primary"
                  type="submit"
                >
            Save and Continue
                </Button>
              </LoneGrid>
              <Grid item md={12}><BackToLogin/></Grid>
            </>
          ) : (
            <LoneGrid>
              <LoginCardSubtitle>
                This link has expired.
                <br/>
                Please try to <Link to="/login">log in</Link> or <Link to="/reset-password">reset your password</Link>.
              </LoginCardSubtitle>
            </LoneGrid>
          ))}
      </Card>
    </Grid>
  );
};
